// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"Feeds_cardContainer__2U4oz"};